import { schema } from "normalizr";
import { userSchema } from "~/store/users/usersNormalizer";
import { clinicSchema } from "~/store/clinics/clinicsNomalizer";

export const consultationSchema = new schema.Entity("consultations", {
  patient: userSchema,
  doctor: userSchema,
  clinic: clinicSchema
});
